import React, { ReactElement } from "react";
import { CSVLink } from "react-csv";
import { FileExcelOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { GraphCSVProps } from "../../../wrappers/LoadingGraph";

export const headers = [
  {
    label: "Year Month",
    key: "month",
  },
  {
    label: "Year",
    key: "year",
  },
  {
    label: "Total SMBs",
    key: "smb_ct",
  },
];

const SMBByMonthTyVsLyCSV = ({ data }: GraphCSVProps): ReactElement => (
  <CSVLink data={data} headers={headers}>
    <Button type="dashed" icon={<FileExcelOutlined />} />
  </CSVLink>
);

export default SMBByMonthTyVsLyCSV;
